// Config option kỳ báo cáo
export default {
  MonthDecember: 12, //tháng 12
  QuarterI: 101, //Quý I
  QuarterII: 102, //Quý II
  QuarterIII: 103, //Quý III
  QuarterIV: 104, //Quý IV
  FirtsHalfYear: 201, //6 tháng đầu năm
  SecondHalfYear: 202, //6 tháng cuối năm
  Year: 203, //Cả năm
}